/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState, useCallback } from 'react';
// redux
import {useDispatch, useSelector} from 'react-redux';
// material
import { SubPage, Copy, BodyCopy, CTAs, Button, displayModal } from '@insticator/insticator-ui'; // iui-material
// styles
import injectSheet from 'react-jss';
import styles from './setthemeconfirm_styles';
import { updateTrendingNowV2DisplayConfig } from 'state/thunks/trendingnowv2';
import { updateDisplayConfig } from 'state/thunks/commenting';
import { setThemeForAllProducts } from 'state/thunks/articlesentimentv2';

/* ========== ~~~~~~~~~~ CANCEL IMPORT POPUP~~~~~~~~~~ ========== */
const SetThemeConfirm = props => {
  const dispatch = useDispatch();
  const { siteUUID, accountUUID } = useSelector(state => state.session);
  const currentPage = useSelector(state => state.app.currentPage);
  const { tempDisplayConfig: tempTrendingNowDisplayConfig, tempTrendingNowConfig } = useSelector(state => state.trendingNowV2)
  const { tempDisplayConfig: tempCommentingDisplayConfig, tempCommentingUnitConfig } = useSelector(state => state.commentingV2)
  const { tempArticleSentimentConfig } = useSelector(state => state.articleSentimentV2)
  const [isSettingTheme, setIsSettingTheme] = useState(false)

  const handleNo = () => dispatch(displayModal(false));

  const handleYes = useCallback(async () => {
    setIsSettingTheme(true)
    if(currentPage.includes('commenting')) {
      const { displayConfig, emojiConfigs } = tempCommentingUnitConfig
      const requestPayload = {
        siteId: siteUUID,
        accountId: accountUUID,
        displayConfig: {...displayConfig},
        emojiConfigs: emojiConfigs
      }
      const response = await dispatch(setThemeForAllProducts(requestPayload))
      if(!response.error)  dispatch(displayModal(false))
    }

    if(currentPage.includes('trendingnow')) {
      const { displayConfig, emojiConfigs } = tempTrendingNowConfig
      const requestPayload = {
        siteId: siteUUID,
        accountId: accountUUID,
        displayConfig: {
            ...displayConfig, 
            customPrimaryColor: displayConfig.primaryColor || '#061240',
            customBackgroundColor: displayConfig.backgroundColor || '#FFFFFF'
        },
        emojiConfigs: emojiConfigs
      }
      const response = await dispatch(setThemeForAllProducts(requestPayload))
      if(!response.error)  dispatch(displayModal(false))
    }

    if(currentPage.includes('articlesentiment')) {
      const { displayConfig, emojiConfigs } = tempArticleSentimentConfig
      const requestPayload = {
        siteId: siteUUID,
        accountId: accountUUID,
        displayConfig: {...displayConfig},
        emojiConfigs: emojiConfigs
      }
      const response = await dispatch(setThemeForAllProducts(requestPayload))
      if(!response.error)  dispatch(displayModal(false))
    }
    setIsSettingTheme(false)
  }, [accountUUID, currentPage, dispatch, siteUUID, tempArticleSentimentConfig, tempCommentingDisplayConfig, tempTrendingNowDisplayConfig])

  return (
    <SubPage name={`setthemeconfirm`} klass={props.classes.setthemeconfirm}>
      <Copy name={`setthemeconfirm`}>
          <h3 className='header'>Set theme for all products</h3>
          <BodyCopy>
            <p><strong>Are you sure you want to apply this theme across all COOL Media products?</strong></p>
            <p>This will only override all available global site themes configurations such as:</p>
            <ul>
              <li>Colors</li>
              <li>Fonts</li>
              {!currentPage.includes('trendingnow') && <li>Emojis</li>}
              <li>Language</li>
            </ul>
          </BodyCopy>
      </Copy>
      <CTAs name={`ctas`} >
        <Button type={`action`} handleClick={handleNo} variant={`none`} color={'light'} name={`cancel`} text={`Cancel`} />
        <Button type={'action'} handleClick={handleYes} variant={`primary`} name={`confirm`} text={`Yes, Set Theme`} processing={isSettingTheme} processingText={'Setting Theme...'} />
      </CTAs>
  </SubPage>
  );
};

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(SetThemeConfirm);
